import { Component, ElementRef, Input, ViewChild, HostBinding } from '@angular/core';
import { BaseToolComponent } from '../base-tool.component';
import { ApplicationData } from 'src/app/data/application.data';
import { ApplicationService } from 'src/app/services/application.service';
import { LabelData } from 'src/app/data/configurator/label/label.data';
import { ModalService } from 'src/app/services/modal.service';
import { SheetPreview } from '../sheet-preview.component';
import { RatioUtil } from 'src/app/tools/ratio.utils';
import { Rectangle } from 'src/app/tools/rectangle';
import { ContextData } from 'src/app/data/context.data';
import { CanvasEvent } from 'src/app/events/canvas.event';
import { CONFIGURATION_MODE } from 'src/app/data/configuration.data';

@Component({
  selector: 'manager-panel',
  templateUrl: './manager-panel.component.html',
  host: {
    class: 'manager-panel'
  }
})
export class ManagerPanelComponent extends BaseToolComponent {

  @Input() set label(data: LabelData) {
    if ((this._labelData && this._labelData != data) || !this._labelData) {
      this.clearCurrentLabel();
      this._labelData = data as LabelData;
      this.setLabel();
    }
  }

  @ViewChild('scroller') public scroller: ElementRef<any>;

  public currentSheet:number = 0;
  public currentDuplicationSheet:number = 0;

  public selectedLabels: Array<LabelData> = [];

  public ratio:number;
  public template:string;

  /**
	 * Constructor
	 */
  constructor(
    public applicationService:ApplicationService,
    public applicationData:ApplicationData,
    private modalService: ModalService
  ) {
    super();
  }

  @HostBinding('class.disabled') get disabled() { return (ContextData.MODE == CanvasEvent.SET_CROP_MODE || this.applicationData.configuration.mode == CONFIGURATION_MODE.EXCEL); }

	/**
	 * On init
	 */
  ngOnInit() {
    for (let labelData of this.applicationData.configuration.labels) {
      labelData.label.redraw();
    }

    let _targetSide = 0;
    let _baseSize = 0;

    // console.log(this.applicationData.configuration);

    if(this.applicationData.configuration.multiFormat){
      this.template = "multiformat";
      _baseSize = this.applicationData.configuration.sheetProperties.pixelsHeight;
      _targetSide = 200;
      // console.log(this.applicationData.configuration.sheetProperties.pixelsHeight);
    } else {
      switch(true){
        case (this.applicationData.configuration.labelRatio > 0.75 && this.applicationData.configuration.labelRatio < 5.89) :
          this.template = "horizontal";
          _baseSize = this._labelData.pixelsHeight;
          _targetSide = 40;
          break;
        case (this.applicationData.configuration.labelRatio >= 5.89) :
          this.template = "horizontal-cut";
          _baseSize = this._labelData.pixelsHeight;
          _targetSide = 40;
          break;
        case (this.applicationData.configuration.labelRatio > 0.65 && this.applicationData.configuration.labelRatio <= 0.75) :
          this.template = "vertical";
          _baseSize = this._labelData.pixelsWidth;
          _targetSide = 50;
          break;
        case (this.applicationData.configuration.labelRatio > 0.32 && this.applicationData.configuration.labelRatio <= 0.65) :
          this.template = "vertical";
          _baseSize = this._labelData.pixelsWidth;
          _targetSide = 30;
          break;
        case (this.applicationData.configuration.labelRatio <= 0.32) :
          this.template = "vertical-cut";
          _baseSize = this._labelData.pixelsWidth;
          _targetSide = 30;
          break;
        default:
          // Tengo un problemo amigo !
      }
    }

    let _size = RatioUtil.scaleToFit(new Rectangle(0, 0, _baseSize,_baseSize), new Rectangle(0,0,_targetSide,_targetSide));
    this.ratio = _size.width / _baseSize;
  }

  /**
    * Display label
  */
  protected setLabel(): void {
    for (let i: number = 0; i < this.applicationData.configuration.labels.length; i++) {
      if (this.applicationData.configuration.labels[i] == this._labelData) {
        this.currentSheet = Math.floor(i / this.applicationData.configuration.sheetProperties.layouts.length);
        break;
      }
    }
  }

  /**
    * Display label
  */
  public addLabel(): void {
    this.applicationData.configuration.addLabel().then(
      (result: any) => {
        setTimeout(() => {
          let configuration = this.applicationData.configuration;
          configuration.displayLabel(configuration.labels[configuration.labels.length - 1]);
          this.scroller.nativeElement.scrollTop = this.scroller.nativeElement.scrollHeight;
          this.scroller.nativeElement.scrollLeft = this.scroller.nativeElement.scrollWidth;
        }, 100);
      },
      (error: any) => {
        console.error(error);
      },
    ).catch((e: Error) => { console.error(e); });
  }

  /**
   * Display sheet
   */
  public addSheet(): void {
    this.applicationData.configuration.addSheet().then(
      (result: any) => {
        let configuration = this.applicationData.configuration;
        configuration.displayLabel(configuration.labels[configuration.labels.length - configuration.sheetProperties.layouts.length]);
      },
      (error: any) => {
        console.error(error);
      },
    ).catch((e: Error) => { console.error(e); });
  }

  /**
   * Next sheet
   */
  public nextSheet(): void {
    if (this.currentSheet < this.applicationData.configuration.sheets.length - 1) {
      this.currentSheet++;
    }
  }

  /**
   * Prev sheet
   */
  public prevSheet(): void {
    if (this.currentSheet > 0 ) {
      this.currentSheet--;
    }
  }

  /**
   * Select label
   */
  public selectLabel(labelData:LabelData): void {
    this.applicationService.currentLayerData = null;
    this.applicationData.configuration.displayLabel(labelData);
  }

  /**
   * Duplicate label
   */
  public requestLabelDuplication(previewsPanel:SheetPreview, labelData:LabelData): void {
    this.currentDuplicationSheet = 0;
    this.selectedLabels = [];
    previewsPanel.reset();
    this.modalService.open('modal-duplication', { label:labelData });
  }
  public duplicateLabel(labelData: LabelData ): void {
    var labelData: LabelData;
    for (let label of this.selectedLabels) {
      label.removeAllLayers();
      label.layers = labelData.cloneLayers();
    }

    this.modalService.cancel('modal-duplication');
  }

  /**
   * Delete label
   */
  public requestLabelDeletion(labelData: LabelData): void {
    this.modalService.open('modal-confirm-label-deletion', { text: 'cfg_labelDeleteConfirmation', label: labelData });
  }

  /**
   * Delete label
   */
  public deleteLabel(labelData: LabelData): void {
    this.applicationData.configuration.deleteLabel(labelData);
    this.modalService.cancel('modal-confirm-label-deletion');
  }

  /**
   * Duplicate sheet
   */
  public requestSheetDeletion(sheetIndex: number): void {
    this.modalService.open('modal-confirm-sheet-deletion', { text: 'cfg_sheetDeleteConfirmation', sheet: sheetIndex });
  }

  /**
   * Delete sheet
   */
  public deleteSheet(sheetIndex: number): void {
    this.applicationData.configuration.deleteSheet(sheetIndex);
    this.modalService.cancel('modal-confirm-sheet-deletion');
  }

	/**
	* On destroy
	*/
  ngOnDestroy() {

  }
}
